import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import {
  TextField,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import axios from "axios";
import Swal from "sweetalert2";
import {DecryptED} from "../../DecryptJS/Decrypt"
import { getWeeklyPlanConfig } from "../weeklyPlanConfig";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  details: {
    display: "flex",
    flexDirection: "column",
  },
  button: {
    height: "40px",
    cursor: "pointer",
  },
}));

const ViewDayPlan = ({ day, weeklyData, setWeeklyData }) => {
  let { sid, userid, reportid } = useParams();
  sid = DecryptED(sid);
  userid = DecryptED(userid)
  const cfg = getWeeklyPlanConfig(sid);
  const classes = useStyles();
  const [msgID, setMsgID] = useState("");
  const [topic, setTopic] = useState("");
  const [period, setPeriod] = useState("");
  const [notes, setNotes] = useState("");
  const [activity, setActivity] = useState("");
  const [outcome, setOutcome] = useState("");
  const [work, setWork] = useState("");
  const [value, setValue] = useState("");
  const [reason, setReason] = useState("");

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const handleSave = (e) => {
    e.preventDefault();
    const obj = {
      id: msgID,
      day,
      top_sub_top: topic,
      no_of_period: period,
      imp_note: notes,
      cls_activity: activity,
      homework: work,
      if_no_reas_with_comp_date: reason,
      ...(cfg.learningOutcomes ? { learning_outcome: outcome } : {}),
    };
    const newArr = weeklyData;
    newArr.push(obj);
    setWeeklyData(newArr);

    Swal.fire({
      position: "center",
      icon: "success",
      title: "Your work has been saved",
      showConfirmButton: false,
      timer: 1500,
    });
  };
  useEffect(() => {
    const getReportData = async () => {
      const data = {
        fun_name: "getWeeklyLessonPlanByID",
        staff_id: userid,
        sid,
        id: reportid,
      };
      const response = await axios.post(
        "https://topschool.prisms.in/rest/index.php/staff_list.json",
        data
      );
      if (response) {
        const obj = response.data.result;
        obj.map((data, key) => {
          if (data.days.toLowerCase() === day.toLowerCase()) {
            setMsgID(data.id);
            setTopic(data.top_sub_top);
            setPeriod(data.no_of_period);
            setNotes(data.imp_note);
            setActivity(data.cls_activity);
            setOutcome(data.learning_outcome || "");
            setWork(data.homework);
            setValue(data.accomplished);
            setReason(data.if_no_reas_with_comp_date);
          }
        });
      }
    };
    getReportData();
  }, []);

  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Typography className={classes.heading}>{day}</Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.details}>
        <TextField
          fullWidth
          id="topic"
          label="Topic/Sub-Topic"
          variant="outlined"
          value={topic}
          onChange={(e) => setTopic(e.target.value)}
        />
        <TextField
          fullWidth
          id="periods"
          label={cfg.periodNumberLabel ? "Period Number" : "No. of Periods"}
          variant="outlined"
          value={period}
          onChange={(e) => setPeriod(e.target.value)}
        />
        <TextField
          fullWidth
          id="notes"
          label={cfg.teacherActivityLabel ? "Teacher's Activity" : "Important Notes"}
          variant="outlined"
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
        />
        <TextField
          fullWidth
          id="activities"
          label="Class Activities"
          variant="outlined"
          value={activity}
          onChange={(e) => setActivity(e.target.value)}
        />
        {cfg.learningOutcomes && (
          <TextField
            fullWidth
            id="outcomes"
            label="Learning Outcomes"
            variant="outlined"
            value={outcome}
            onChange={(e) => setOutcome(e.target.value)}
          />
        )}
        <TextField
          fullWidth
          id="homework"
          label={cfg.assignmentLabel ? "Assignment" : "Home Work"}
          variant="outlined"
          value={work}
          onChange={(e) => setWork(e.target.value)}
        />
        {!cfg.hideAccomplished && (
          <>
            <FormControl component="fieldset">
              <FormLabel component="legend">Accomplished</FormLabel>
              <RadioGroup
                aria-label="accomplished"
                name="accomplished"
                value={value}
                onChange={handleChange}
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
            {value === "no" ? (
              <TextField
                fullWidth
                id="reason"
                label="If No Reason With Completion"
                variant="outlined"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              />
            ) : (
              ""
            )}
          </>
        )}
        <Button
          onClick={(e) => handleSave(e)}
          className={classes.button}
          variant="contained"
          color="primary"
        >
          Save!
        </Button>
      </AccordionDetails>
    </Accordion>
  );
};

export default ViewDayPlan;
